import { render, staticRenderFns } from "./PastAwardsVideoLink.vue?vue&type=template&id=688079b7&scoped=true"
import script from "./PastAwardsVideoLink.vue?vue&type=script&lang=js"
export * from "./PastAwardsVideoLink.vue?vue&type=script&lang=js"
import style0 from "./PastAwardsVideoLink.vue?vue&type=style&index=0&id=688079b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688079b7",
  null
  
)

/* custom blocks */
import block0 from "./PastAwardsVideoLink.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports